module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};



//////////////////
// WEBPACK FOOTER
// /home/runner/work/onelocal/onelocal/src/my-referral/~/.pnpm/core-js@2.6.12/~/core-js/modules/_is-object.js
// module id = ../../../../../../core-js@2.6.12/node_modules/core-js/modules/_is-object.js
// module chunks = 0